export var ShowtimeRestriction;
(function(ShowtimeRestriction) {
    ShowtimeRestriction[/**
     * The criteria of the [[FilmAdvanceBookingRule]] with the specified [[AdvanceBookingShowtime.filmAdvanceBookingRuleId]] must be satisfied.
     */ "FilmAdvanceBookingRule"] = "FilmAdvanceBookingRule";
})(ShowtimeRestriction || (ShowtimeRestriction = {}));

//# sourceMappingURL=showtime-restriction.js.map